/*
 * Attachment.tsx
 *
 * @Author: xiaoJQ
 * @Date: 2024-06-07 17:32:31
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { changeMainPageFileAction } from 'store/actioin/action';
import { useSelector } from 'store/hook/useSelector';
import Table from 'components/common/table';
import { toYMDHMS } from 'components/util/util';
import Styles from './index.less';
export var ATTACHMENTTABLEDATA = {
    COLUMN: [
        {
            key: 'index',
            isShow: true,
            title: '序号',
            froze: false,
            style: {
                minWidth: 100,
                maxWidth: 100,
                justifyContent: 'center',
            },
            render: function renderBlock(data) {
                return React.createElement("span", { key: "index".concat(data.id) }, data['index']);
            },
        },
        {
            key: 'fileName',
            isShow: true,
            title: '附件名称',
            froze: false,
            style: { minWidth: 270, maxWidth: 270, justifyContent: 'flex-start' },
            render: function renderBlock(data) {
                return React.createElement("span", { key: "fileName".concat(data.id) }, data['fileName']);
            },
        },
        {
            key: 'userName',
            isShow: true,
            title: '上传人',
            froze: false,
            style: { minWidth: 270, maxWidth: 270, justifyContent: 'flex-start' },
            render: function renderBlock(data) {
                return React.createElement("span", { key: "userName".concat(data.id) }, data['userName']);
            },
        },
        {
            key: 'uploadTime',
            isShow: true,
            title: '上传时间',
            froze: false,
            style: { minWidth: 270, maxWidth: 270, justifyContent: 'flex-start' },
            render: function renderBlock(data) {
                return (React.createElement("span", { key: "uploadTime".concat(data.id) }, data['endDate'] === 0 ? '' : toYMDHMS(data['uploadTime'])));
            },
        },
        {
            key: 'url',
            isShow: false,
            title: '文件地址',
            froze: false,
            style: { minWidth: 270, maxWidth: 270, justifyContent: 'flex-start' },
            render: function renderBlock(data) {
                return React.createElement("span", { key: "url".concat(data.id) }, data['url']);
            },
        },
        {
            key: 'fileType',
            isShow: false,
            title: '文件类型',
            froze: false,
            style: { minWidth: 270, maxWidth: 270, justifyContent: 'flex-start' },
            render: function renderBlock(data) {
                return React.createElement("span", { key: "fileType".concat(data.id) }, data['fileType']);
            },
        },
        {
            key: 'fileSize',
            isShow: false,
            title: '文件大小',
            froze: false,
            style: { minWidth: 270, maxWidth: 270, justifyContent: 'flex-start' },
            render: function renderBlock(data) {
                return React.createElement("span", { key: "fileSize".concat(data.id) }, data['fileSize']);
            },
        },
    ],
};
var Attachment = function (props) {
    var dispatch = useDispatch();
    var model = useSelector(function (state) { var _a; return (_a = state.global) === null || _a === void 0 ? void 0 : _a.model; });
    var _a = useState({
        key: 'defaultActivePageLabelKey',
        name: '',
        data: [],
    }), activePageLabel = _a[0], setActivePageLabel = _a[1];
    var _b = useState(null), selectAttachmentItem = _b[0], setSelectAttachmentItem = _b[1];
    useEffect(function () {
        if (props.data.attachment.length > 0) {
            setActivePageLabel(props.data.attachment[0]);
        }
        else {
            setActivePageLabel({
                key: 'defaultActivePageLabelKey',
                name: '',
                data: [],
            });
        }
    }, [props.data.attachment]);
    useEffect(function () {
        if (props.saveAttachment.status && selectAttachmentItem) {
            setTimeout(function () {
                var fileName = selectAttachmentItem.fileName, fileType = selectAttachmentItem.fileType, url = selectAttachmentItem.url;
                dispatch(changeMainPageFileAction(fileName, fileType, url, 'loading', true));
                model.invokeAsync('validExtractFile', {
                    fileName: fileName,
                    url: url,
                    type: '',
                });
            }, 200);
            props.saveAttachment.callback && props.saveAttachment.callback();
        }
    }, [props.saveAttachment]);
    var getLabelStyle = function (labelData) {
        if (labelData.key === activePageLabel.key) {
            return {
                border: '1px solid #5582F3',
                color: '#FFFFFF',
                backgroundColor: '#5582F3',
            };
        }
        else {
            return {
                border: '1px solid #D9D9D9',
                color: '#666666',
                backgroundColor: '#FFFFFF',
            };
        }
    };
    var renderPageLabel = function () {
        return props.data.attachment.map(function (item) { return (React.createElement("div", { key: item.key, onClick: function () { return setActivePageLabel(item); }, style: getLabelStyle(item), className: Styles.labels }, item.name)); });
    };
    return (React.createElement("div", { className: Styles.AttachmentBody },
        React.createElement("div", { className: Styles.AttachmentPageLabel }, renderPageLabel()),
        React.createElement(Table, { column: ATTACHMENTTABLEDATA.COLUMN, dataSource: activePageLabel.data
                .filter(function (item) { return item.fileSize <= 10 * 1024 * 1024; })
                .map(function (data, index) {
                return __assign(__assign({}, data), { index: index + 1 });
            }), onSelect: function (item) {
                setSelectAttachmentItem(item);
            }, selectItem: selectAttachmentItem })));
};
export default connect(function (state) { return state; })(Attachment);
